const updates = [
  {
    date: '2024.01.15',
    title: '《长安十二时辰》番外篇全集上线',
    desc: '马伯庸宇宙最新力作，原班人马回归，12集一次更新，追剧不等待。',
    tag: '新剧上线',
  },
  {
    date: '2024.01.14',
    title: '《首尔告白》第8集更新',
    desc: '男女主角感情线迎来重大转折，本集高甜预警，建议备好纸巾。',
    tag: '热播更新',
  },
  {
    date: '2024.01.13',
    title: '《深海密码》完结撒花',
    desc: '12集紧凑悬疑剧完美收官，开放结局引发全网热议，第二季正在筹备中。',
    tag: '剧集完结',
  },
  {
    date: '2024.01.12',
    title: '《山河故人》限时重温活动开启',
    desc: '豆瓣9.2分神作，全48集限时免费重温，经典永不过时。',
    tag: '限时活动',
  },
  {
    date: '2024.01.11',
    title: '《边境追凶》定档1月20日',
    desc: '全新国产硬核刑侦剧，实力派演员集结，预约人数已破百万。',
    tag: '即将上线',
  },
  {
    date: '2024.01.10',
    title: '平台技术升级公告',
    desc: '全面优化视频加载速度，新增4K超清画质选项，投屏体验大幅提升。',
    tag: '系统公告',
  },
  {
    date: '2024.01.09',
    title: '《月光变奏曲》OST全网上线',
    desc: '由韩国顶级制作人操刀，15首原创歌曲，网易云/QQ音乐同步上架。',
    tag: '音乐上线',
  },
  {
    date: '2024.01.08',
    title: '2024年1月观剧指南发布',
    desc: '本月将上线12部新剧，涵盖古装、悬疑、爱情等多种题材，值得期待。',
    tag: '月度推荐',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
            更新动态
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            最新剧集上线、活动公告和平台动态，不错过任何精彩
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] md:left-[23px] top-0 bottom-0 w-px bg-background-300"></div>

          <div className="space-y-6">
            {updates.map((item) => (
              <div key={item.title} className="relative pl-10 md:pl-12">
                <div className="absolute left-[11px] md:left-[15px] top-1.5 w-4 h-4 rounded-full border-2 border-primary-500 bg-background-50"></div>

                <div className="bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/60">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                    <span className="hidden sm:block text-foreground-300 mx-1">·</span>
                    <span className="inline-block px-2 py-0.5 text-[10px] font-medium rounded-full bg-accent-100 text-accent-700 whitespace-nowrap w-fit">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm font-heading font-semibold text-foreground-800 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}